import React, { Component, Fragment } from 'react';
import { TEACHER_MENU } from 'config/constants';
import { withRouter } from 'react-router';

import TeacherNavLink from '../TeacherNavLink';

import './style.css';

class TeacherNavbar extends Component {
  render() {
    const { location } = this.props;

    const selectedMenu = TEACHER_MENU.find(menu => location.pathname.includes(menu.path));
    const hasSubmenu = Boolean(selectedMenu && selectedMenu.submenu);

    return (
      <Fragment>
        <div className="teacher-nav-bar">
          <nav className="nav nav-pills flex-column">
            {TEACHER_MENU.map((item, index) => (
              <TeacherNavLink
                key={index}
                to={item.path}
                title={item.title}
                icon={item.icon}
                active={selectedMenu && item.title === selectedMenu.title}
                hideText={hasSubmenu}
              />
            ))}
          </nav>
        </div>
        {hasSubmenu && (
          <div className="teacher-nav-bar teacher-nav-bar--sub">
            <h6 className="teacher-nav-bar__title px-4 my-3">{selectedMenu.title}</h6>
            <nav className="nav nav-pills flex-column">
              {selectedMenu.submenu.map((item, index) => (
                <TeacherNavLink
                  key={index}
                  to={item.path}
                  title={item.title}
                  active={location.pathname.includes(item.path)}
                  submenu
                />
              ))}
            </nav>
          </div>
        )}
      </Fragment>
    );
  }
}

export default withRouter(TeacherNavbar);



// WEBPACK FOOTER //
// ./src/components/navigation/TeacherNavbar/index.js